import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class GetCurrencyInfoQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(currency_id:string): Promise<any> {
    let args = {
      currency_id: currency_id
    }
    let res = await this.dispatcher.dispatch('currency_info', args)
    if (res) {
      this.frontend.currency_info = res
    }
  }
}